<template>
  <div>
    <v-container fluid grid-list-md text-xs-center>
      <v-layout row wrap style="padding-top:15px">
        <!-- State Franchise -->
        
        <v-flex md4 sm12 xs12 style="padding-top:15px">
           <v-card class="elevation-4 txt_dec"  style="cursor: pointer;border: 1px solid; border-color:primary;">
              <v-sheet
                class="v-sheet--offset mx-auto"
                dark
                color="transparent"
                max-width="calc(100% - 10px)"
              >
                <v-toolbar style="border-radius: 8px !important;background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);background-size:cover">
                  <v-icon :size="33">account_box</v-icon>
                  
                  <v-spacer></v-spacer>
                  <v-toolbar-title>My Profile</v-toolbar-title>
                </v-toolbar>
              </v-sheet>
              <h1 style="text-align:center;margin-top:-25px !important;font-weight:bold" class="primary--text">Sk Majid</h1>
            </v-card>
          </v-flex>

        <v-flex md4 sm12 xs12 style="padding-top:15px">
           <v-card class="elevation-4 txt_dec" style="cursor: pointer;border: 1px solid; border-color:primary;">
              <v-sheet
                class="v-sheet--offset mx-auto"
                dark
                color="transparent"
                max-width="calc(100% - 10px)"
              >
                <v-toolbar style="border-radius: 8px !important;background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);background-size:cover">
                  <v-icon :size="33">burst_mode</v-icon>
                  
                  <v-spacer></v-spacer>
                  <v-toolbar-title>My Blog</v-toolbar-title>
                </v-toolbar>
              </v-sheet>
              <h1 style="text-align:center;margin-top:-25px !important;font-weight:bold" class="primary--text">2</h1>
            </v-card>
          </v-flex>

          <v-flex md4 sm12 xs12 style="padding-top:15px">
           <v-card class="elevation-4 txt_dec"  style="cursor: pointer;border: 1px solid; border-color:primary;">
              <v-sheet
                class="v-sheet--offset mx-auto"
                dark
                color="transparent"
                max-width="calc(100% - 10px)"
              >
                <v-toolbar style="border-radius: 8px !important;background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);background-size:cover">
                  <v-icon :size="33">local_car_wash</v-icon>
                  
                  <v-spacer></v-spacer>
                  <v-toolbar-title>My Tour</v-toolbar-title>
                </v-toolbar>
              </v-sheet>
              <h1 style="text-align:center;margin-top:-25px !important;font-weight:bold" class="primary--text">1</h1>
            </v-card>
          </v-flex>

      </v-layout>

    </v-container>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import Vue from "vue";
import config from "../../../config.json";

export default {
  components: {
    Avatar
  },

  
  data() {
    return {
      roleType: sessionStorage.roles,
      dashboardData: {
        hotel: null,
        commission: null
      }
    };
  },

  methods: {
    
  },

  created() {
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 6px !important;
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -60px;
  position: relative;
}
.shdw:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>
